// extracted by mini-css-extract-plugin
export default {"containerNCM":"ncmViewContainer_containerNCM__kkOzw","botoes":"ncmViewContainer_botoes__YA9EH"};